// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as $$Array from "bs-platform/lib/es6/array.js";
import * as React from "react";
import * as Link$Xuder from "./Link.bs.js";

require("./NavBar.css");

var navValue = /* array */[
  /* record */[
    /* route */"/",
    /* displayStr */"Home"
  ],
  /* record */[
    /* route */"/about",
    /* displayStr */"About"
  ],
  /* record */[
    /* route */"/compose",
    /* displayStr */"Compose"
  ]
];

function NavBar(Props) {
  return React.createElement("nav", {
              className: "xuder-navbar"
            }, React.createElement("ul", undefined, $$Array.map((function (value) {
                        return React.createElement("li", undefined, React.createElement(Link$Xuder.make, {
                                        route: value[/* route */0],
                                        children: value[/* displayStr */1]
                                      }));
                      }), navValue)));
}

var make = NavBar;

export {
  navValue ,
  make ,
  
}
/*  Not a pure module */
